<template>
  <div>
    <el-button
      style="margin-bottom: 20px;"
      type="primary"
      @click="setsu('null')"
      v-if="hasAuth('sys:amount:add')"
      >添加</el-button
    >
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%;"
      border
      stripe
    >
      <el-table-column
        label="金额"
        align="center"
        prop="money"
      ></el-table-column>
      <el-table-column label="操作" align="center" prop="icon" fixed="right">
        <template slot-scope="scope">
          <el-popconfirm
            title="确定删除吗？"
            @confirm="delHandle(scope.row.id)"
          >
            <el-button type="danger" plain slot="reference" v-if="hasAuth('sys:amount:del')">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="添加"
      :visible.sync="dialogVisible"
      width="800px"
      append-to-body
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        ref="editForm"
        label-width="100px"
        class="demo-editForm"
      >
        <el-form-item label-width="100px" label="金额">
          <el-input v-model="money"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="submitForm()">完成</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import VploadImg from "../inc/VploadImgTwo";
export default {
  name: "amount",
  components: {
    VploadImg,
  },
  data() {
    return {
      searchForm: {},
      shopForm: {},
      tableData: [],
      multipleSelection: [],
      editForm: {},
      dialogVisible: false,
      money: null,
    };
  },
  created() {
    this.getConfig();
  },
  methods: {
    getConfig() {
      this.$axios.post("/admin/rechargeAmount/getList", {}).then((res) => {
        this.tableData = res.data;
      });
    },
    delHandle(id) {
      this.$axios
        .post("/admin/rechargeAmount/del", {
          id: id,
        })
        .then((res) => {
          this.getConfig();
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {},
          });
        });
    },

    setsu() {
      this.id = "";
      this.reason = "";
      this.sort = 0;
      this.dialogVisible = true;
    },

    handleClose() {
      this.dialogVisible = false;
    },
    submitForm() {
      if (!this.money) {
        this.$message({
          showClose: true,
          message: "请输入金额",
          type: "info",
          onClose: () => {},
        });
        return;
      }
      this.$axios
        .post("/admin/rechargeAmount/add", {
          money: this.money,
        })
        .then((res) => {
          this.dialogVisible = false;
          this.getConfig();
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {},
          });
        });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
